import { Col, Flex, message, Row } from "antd";
import { useNavigate, useParams } from "react-router-dom";
import { useMutation, useQuery } from "@tanstack/react-query";
import {
  deleteEmailTemplateById,
  fetchEmailTemplateById,
} from "../../../lib/api/resources/emailTemplates";
import { EmailTemplateDetailCard } from "./components/EmailTemplateDetailCard";
import { EmailTemplatePreview } from "./components/EmailTemplatePreview";

export const EmailTemplateDetail = () => {
  const { id } = useParams();
  const navigate = useNavigate();

  if (!id) return null;

  const { data, isLoading } = useQuery({
    queryKey: ["emailTemplate", id],
    queryFn: () => fetchEmailTemplateById(id),
  });

  const deleteTemplateMutation = useMutation({
    mutationFn: () => deleteEmailTemplateById(id),
    onSuccess: () => {
      navigate(`/email-templates`);
      message.success("Email Template succesvol verwijderd");
    },
    onError: () =>
      message.error(
        "Er is een fout opgetreden bij het verwijderen van de Email Template",
      ),
  });

  return (
    <div>
      <Row gutter={[16, 16]}>
        <Col span={12}>
          <Flex vertical gap={16}>
            <EmailTemplateDetailCard
              deleteMutation={deleteTemplateMutation}
              template={data}
              isLoading={isLoading}
            />
          </Flex>
        </Col>

        <Col span={12}>
          <EmailTemplatePreview title="Email preview" html={data?.html} />
        </Col>
      </Row>
    </div>
  );
};
